var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h5',[_vm._v("Apple Pay付款說明")]),_c('ul',{staticClass:"has-type-decimal"},[_c('li',[_vm._v("限用 iOS 裝置(須軟體版本 13 以上)及 Safari 瀏覽器。")]),_c('li',[_vm._v("使用 Apple Pay 恕不適用分期付款。")])])])
}]

export { render, staticRenderFns }